module.exports = function() {
  return new Worker(__webpack_public_path__ + "42f9e4aa311dbad7adcc.worker.js");
};